// @flow

import { useEffect, useState, useCallback } from 'react';
import Logging from '@ta/common.logging';

export default function usePageVisibility(callback: string => any, isDebug: boolean = false) {
  /* eslint-disable no-restricted-globals */
  const [visibility, setVisibility] = useState('visible');
  const handleChange = useCallback(() => setVisibility(document.visibilityState), []);
  if (typeof window !== 'undefined') {
    document.removeEventListener('visibilitychange', handleChange);
    document.addEventListener('visibilitychange', handleChange);
  }

  useEffect(
    () => () => {
      if (typeof window !== 'undefined') {
        document.removeEventListener('visibilitychange', handleChange);
      }
    },
    [handleChange],
  );

  if (isDebug) {
    Logging.debug('visibility refreshed: ', visibility);
  }
  callback(visibility);
}
